import axios from 'axios';

const url = 'https://disease.sh/v3/covid-19';

export const fetchData = async (country) => {
  let changeableUrl = `${url}/all`;

  if (country) {
    changeableUrl = `${url}/countries/${country}`;
  }

  try {
    const { data } = await axios.get(changeableUrl);

    return {
      confirmed: { value: data.cases },
      recovered: { value: data.recovered },
      deaths: { value: data.deaths },
      lastUpdate: new Date(data.updated).toISOString(),
    };
  } catch (error) {
    console.error('Error fetching data:', error);
    return {
      confirmed: { value: 0 },
      recovered: { value: 0 },
      deaths: { value: 0 },
      lastUpdate: new Date().toISOString(),
    };
  }
};

export const fetchDailyData = async () => {
  try {
    const { data } = await axios.get(`${url}/historical/all?lastdays=120`);

    const dates = Object.keys(data.cases);
    return dates.map((date) => ({
      confirmed: data.cases[date],
      deaths: data.deaths[date],
      date,
    }));
  } catch (error) {
    console.error('Error fetching daily data:', error);
    return [];
  }
};

export const fetchCountries = async () => {
  try {
    const { data } = await axios.get(`${url}/countries`);

    return data.map((country) => country.country);
  } catch (error) {
    console.error('Error fetching countries:', error);
    return [];
  }
};
